import { StarIcon } from "@chakra-ui/icons";
import { Flex, Text } from "@chakra-ui/react";
import { memo } from "react";

import Swipeable from "components/Swipeable";

const customSliderDotProps = (currentIndex, activeIndex) => ({
  w: 2,
  h: 2,
  opacity: currentIndex === activeIndex ? 1 : 0.3
});

const customSliderProps = {
  mt: "24px"
};

const FeedbackSection = () => (
  <Flex my="40px">
    <Swipeable
      itemsToShow={1}
      showSlider
      showPercent={false}
      customSliderDotProps={customSliderDotProps}
      customSliderProps={customSliderProps}
    >
      {[1, 2, 3].map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Flex direction="column" key={index}>
          <Flex mb="20px" justifyContent="center">
            {Array(5)
              .fill(1)
              .map((item, currentIndex) => (
                // eslint-disable-next-line react/no-array-index-key
                <StarIcon key={`star-${currentIndex}`} m="2px" color="primary.300" />
              ))}
          </Flex>
          <Flex mb="16px" justifyContent="center">
            <Text fontSize="xs" whiteSpace="pre-line" textAlign="center">
              {`“This program has seriously helped me with something I never thought I’d feel comfortable addressing.
        So thanks for the work you’re doing.”`}
            </Text>
          </Flex>
          <Flex justifyContent="center">
            <Text fontSize="sm" fontWeight="bold">
              ANDY TAN Y.K, NOAH MEMBER
            </Text>
          </Flex>
        </Flex>
      ))}
    </Swipeable>
  </Flex>
);

export default memo(FeedbackSection);
